import React from 'react';
import { Link } from 'react-router';
import { GraduationCap } from 'lucide-react';

export interface PlanNoStudentsEmptyStateProps {
    /** Tab-specific line, e.g. "You need to create a student before you can approve units." */
    description: string;
    /** Optional outer wrapper (e.g. min-height for Create / Add Topics layout) */
    wrapperClassName?: string;
}

/**
 * Shared "no students" watermark for My Plan tabs — same layout as Approve Units, In Progress, Completed.
 */
export function PlanNoStudentsEmptyState({ description, wrapperClassName }: PlanNoStudentsEmptyStateProps) {
    const inner = (
        <div className="bg-white rounded-lg border border-gray-200 p-8 text-center">
            <GraduationCap className="mx-auto h-12 w-12 text-gray-400 mb-4" />
            <h3 className="text-lg font-semibold text-gray-900 mb-2">No Students Found</h3>
            <p className="text-gray-600 mb-4">{description}</p>
            <p className="text-sm text-gray-500">
                Please go to{' '}
                <Link
                    to="/app/profiles/students"
                    className="font-medium text-action-blue hover:text-action-blue-dark"
                >
                    Profiles
                </Link>{' '}
                to add a student first.
            </p>
        </div>
    );

    if (wrapperClassName) {
        return <div className={wrapperClassName}>{inner}</div>;
    }

    return inner;
}
